<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Moneda" resource="monedas" primaryKey="idmoneda" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import MonedaService from "@/services/moneda.service";
import { moneda } from "@/models/moneda";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: moneda,
      service: MonedaService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        MonedaService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
